"use client";

import "./drawer.global.scss";

import { FC, useRef } from "react";
import DrawerPortal from "react-bottom-drawer";

import { useClickOutside } from "@/hooks";
import { useUIStore } from "@/stores";


const Drawer: FC = () => {
  const contentRef = useRef<HTMLDivElement>(null);

  const closeDrawer = useUIStore((state) => state.actions.drawer.closeDrawer);
  const { isOpened, component: DrawerComponent, data } = useUIStore((state) => state.drawer);

  useClickOutside(contentRef, closeDrawer);

  if (!data || !DrawerComponent) return null;

  return (
    <DrawerPortal isVisible={isOpened}  className="drawer" onClose={closeDrawer}>
      <DrawerComponent {...data} />
    </DrawerPortal>
  );
};

export { Drawer };
